module.exports = __webpack_public_path__ + "static/media/db.77364e32.png";